// extracted by mini-css-extract-plugin
export default {"emptyState":"_2Hf8y","image":"_3oRN3","title":"_1oPxn","subTitle":"_22fMr","button":"mhhK7","subTitleLetgo":"ZCv6r","sellButton":"_1JexT","whiteTitle":"_3DR3d"};